var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1284_323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.722 188.333H199.824V188.453H215.722V188.333Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.75 189.633H154.579V189.753H158.75V189.633Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.339 183.874H190.128V183.994H199.339V183.874Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6816 184.68H24.9504V184.8H45.6816V184.68Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.992 184.68H49.9536V184.8H52.992V184.68Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.842 186.706H62.8754V186.826H107.842V186.706Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.432 161.597H21.744C21.0179 161.597 20.3215 161.309 19.8076 160.796C19.2938 160.283 19.0044 159.587 19.0032 158.861V28.5695C19.0044 27.8434 19.2938 27.1475 19.8076 26.6346C20.3215 26.1216 21.0179 25.8335 21.744 25.8335H114.432C115.158 25.8335 115.854 26.1216 116.368 26.6346C116.882 27.1475 117.172 27.8434 117.173 28.5695V158.88C117.166 159.603 116.875 160.294 116.362 160.802C115.848 161.311 115.155 161.597 114.432 161.597ZM21.744 25.9535C21.0497 25.9535 20.3838 26.229 19.8925 26.7194C19.4011 27.2099 19.1244 27.8752 19.1232 28.5695V158.88C19.1244 159.574 19.4011 160.24 19.8925 160.73C20.3838 161.22 21.0497 161.496 21.744 161.496H114.432C115.126 161.496 115.792 161.22 116.283 160.73C116.775 160.24 117.051 159.574 117.053 158.88V28.5695C117.051 27.8752 116.775 27.2099 116.283 26.7194C115.792 26.229 115.126 25.9535 114.432 25.9535H21.744Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.256 161.597H125.568C124.842 161.597 124.146 161.309 123.632 160.796C123.118 160.283 122.829 159.587 122.827 158.861V28.5695C122.829 27.8434 123.118 27.1475 123.632 26.6346C124.146 26.1216 124.842 25.8335 125.568 25.8335H218.256C218.982 25.8335 219.679 26.1216 220.192 26.6346C220.706 27.1475 220.996 27.8434 220.997 28.5695V158.88C220.991 159.603 220.699 160.294 220.186 160.802C219.672 161.311 218.979 161.597 218.256 161.597ZM125.568 25.9535C124.874 25.9535 124.208 26.229 123.717 26.7194C123.225 27.2099 122.949 27.8752 122.947 28.5695V158.88C122.949 159.574 123.225 160.24 123.717 160.73C124.208 161.22 124.874 161.496 125.568 161.496H218.256C218.95 161.496 219.616 161.22 220.108 160.73C220.599 160.24 220.876 159.574 220.877 158.88V28.5695C220.876 27.8752 220.599 27.2099 220.108 26.7194C219.616 26.229 218.95 25.9535 218.256 25.9535H125.568Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.77 183.005H-0.230347V183.125H239.77V183.005Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.509 112.306H107.683V170.405H138.509V112.306Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.602 104.856V112.306H116.035H130.157H132.59V104.856H113.602Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.602 114.278H109.656V118.224H113.602V114.278Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.248 114.278H117.302V118.224H121.248V114.278Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89 114.278H124.944V118.224H128.89V114.278Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.536 114.278H132.59V118.224H136.536V114.278Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.602 121.45H109.656V125.395H113.602V121.45Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.248 121.45H117.302V125.395H121.248V121.45Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89 121.45H124.944V125.395H128.89V121.45Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.536 121.45H132.59V125.395H136.536V121.45Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.602 128.616H109.656V132.561H113.602V128.616Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.248 128.616H117.302V132.561H121.248V128.616Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89 128.616H124.944V132.561H128.89V128.616Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.248 108.077H117.302V112.022H121.248V108.077Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89 108.077H124.944V112.022H128.89V108.077Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.536 128.616H132.59V132.561H136.536V128.616Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.602 135.787H109.656V139.733H113.602V135.787Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.248 135.787H117.302V139.733H121.248V135.787Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89 135.787H124.944V139.733H128.89V135.787Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.536 135.787H132.59V139.733H136.536V135.787Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.602 142.958H109.656V146.904H113.602V142.958Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.248 142.958H117.302V146.904H121.248V142.958Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89 142.958H124.944V146.904H128.89V142.958Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.536 142.958H132.59V146.904H136.536V142.958Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.602 150.129H109.656V154.075H113.602V150.129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.248 150.129H117.302V154.075H121.248V150.129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89 150.129H124.944V154.075H128.89V150.129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.536 150.129H132.59V154.075H136.536V150.129Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.602 157.301H109.656V161.246H113.602V157.301Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.248 157.301H117.302V161.246H121.248V157.301Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.89 157.301H124.944V161.246H128.89V157.301Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.536 157.301H132.59V161.246H136.536V157.301Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.045 112.344H139.142V111.537H107.045V112.344Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.542 102.245H71.8993V170.405H108.542V102.245Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9362 93.3887V102.245H81.8258H98.6162H101.506V93.3887H78.9362Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1409 102.292H109.296V101.337H71.1409V102.292Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.981 93.3887H102.466V92.4335H77.981V93.3887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.901 102.245H64.2577V170.405H100.901V102.245Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2944 93.3887V102.245H74.184H90.9744H93.864V93.3887H71.2944Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2943 104.587H66.6047V109.277H71.2943V104.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3808 104.587H75.6912V109.277H80.3808V104.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4673 104.587H84.7777V109.277H89.4673V104.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5536 104.587H93.864V109.277H98.5536V104.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2943 113.112H66.6047V117.801H71.2943V113.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3808 113.112H75.6912V117.801H80.3808V113.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4673 113.112H84.7777V117.801H89.4673V113.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5536 113.112H93.864V117.801H98.5536V113.112Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2943 121.637H66.6047V126.326H71.2943V121.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3808 121.637H75.6912V126.326H80.3808V121.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4673 121.637H84.7777V126.326H89.4673V121.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3808 97.2192H75.6912V101.909H80.3808V97.2192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4673 97.2192H84.7777V101.909H89.4673V97.2192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5536 121.637H93.864V126.326H98.5536V121.637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2943 130.162H66.6047V134.851H71.2943V130.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3808 130.162H75.6912V134.851H80.3808V130.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4673 130.162H84.7777V134.851H89.4673V130.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5536 130.162H93.864V134.851H98.5536V130.162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2943 138.686H66.6047V143.376H71.2943V138.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3808 138.686H75.6912V143.376H80.3808V138.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4673 138.686H84.7777V143.376H89.4673V138.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5536 138.686H93.864V143.376H98.5536V138.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2943 147.206H66.6047V151.896H71.2943V147.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3808 147.206H75.6912V151.896H80.3808V147.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4673 147.206H84.7777V151.896H89.4673V147.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5536 147.206H93.864V151.896H98.5536V147.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2943 155.731H66.6047V160.421H71.2943V155.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3808 155.731H75.6912V160.421H80.3808V155.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4673 155.731H84.7777V160.421H89.4673V155.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5536 155.731H93.864V160.421H98.5536V155.731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.5041 102.292H101.659V101.337H63.5041V102.292Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3392 93.3887H94.824V92.4335H70.3392V93.3887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8162 133.118H25.3058V170.131H58.037V133.118V118.829L45.8162 133.118Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1473 118.829H58.0369V170.131H64.1473V118.829Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.704 139.646H26.832V144.518H31.704V139.646Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.7039 139.646H27.3743V144.518H31.7039V139.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.704 147.845H26.832V152.717H31.704V147.845Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.7039 147.845H27.3743V152.717H31.7039V147.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.704 156.038H26.832V160.91H31.704V156.038Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M31.7039 156.038H27.3743V160.91H31.7039V156.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32.2463 156.038H27.3743V160.91H32.2463V156.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.917 139.646H35.045V144.518H39.917V139.646Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.9169 139.646H35.5873V144.518H39.9169V139.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.917 147.845H35.045V152.717H39.917V147.845Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.9169 147.845H35.5873V152.717H39.9169V147.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.917 156.038H35.045V160.91H39.917V156.038Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.9169 156.038H35.5873V160.91H39.9169V156.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.4593 156.038H35.5873V160.91H40.4593V156.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1297 139.646H43.2577V144.518H48.1297V139.646Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.1296 139.646H43.8V144.518H48.1296V139.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1297 147.845H43.2577V152.717H48.1297V147.845Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.1296 147.845H43.8V152.717H48.1296V147.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1297 156.038H43.2577V160.91H48.1297V156.038Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M48.1296 156.038H43.8V160.91H48.1296V156.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.672 156.038H43.8V160.91H48.672V156.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3378 139.646H51.4658V144.518H56.3378V139.646Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M56.3377 139.646H52.0081V144.518H56.3377V139.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3378 147.845H51.4658V152.717H56.3378V147.845Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M56.3377 147.845H52.0081V152.717H56.3377V147.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3378 156.038H51.4658V160.91H56.3378V156.038Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M56.3377 156.038H52.0081V160.91H56.3377V156.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M56.8848 156.038H52.0128V160.91H56.8848V156.038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.832 53.0209L177.615 52.8769C178.068 52.871 178.514 52.9978 178.896 53.2417C182.938 57.0817 187.594 54.8641 189.663 53.5201C190.45 53.0047 191.367 52.7219 192.307 52.7041L206.549 52.5409C211.896 52.4785 213.101 44.9809 208.032 43.2865L207.84 43.2001C213.37 38.4865 201.005 28.8001 187.853 42.5521C188.842 38.0113 177.029 39.7825 173.482 46.0033C172.147 41.9809 160.949 49.1617 164.832 53.0209Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7857 71.9182H113.011C115.728 71.9182 116.371 68.1118 113.818 67.219L113.717 67.1854C116.558 64.819 110.328 59.827 103.555 66.739C104.083 64.435 98.0641 65.2654 96.2257 68.4094C95.5729 66.3454 89.8321 69.931 91.7857 71.9182Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3664 53.688H68.424C73.0416 53.688 74.1552 47.2224 69.792 45.7007L69.624 45.6479C74.4528 41.6255 63.864 33.168 52.344 44.8848C53.2416 40.9728 43.0176 42.3888 39.8928 47.7264C38.7984 44.2224 29.0496 50.3088 32.3664 53.688Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.669 126.922H101.097V173.899H131.669V126.922Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M126.509 126.917H101.097V173.899H126.509V126.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M131.673 126.917H126.509V173.899H131.673V126.917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.825 129.307H103.281V134.851H108.825V129.307Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.573 129.307H111.029V134.851H116.573V129.307Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.325 129.307H118.781V134.851H124.325V129.307Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.825 136.531H103.281V142.075H108.825V136.531Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.573 136.531H111.029V142.075H116.573V136.531Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.325 136.531H118.781V142.075H124.325V136.531Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.825 143.755H103.281V149.299H108.825V143.755Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.573 143.755H111.029V149.299H116.573V143.755Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.325 143.755H118.781V149.299H124.325V143.755Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.825 150.979H103.281V156.523H108.825V150.979Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.573 150.979H111.029V156.523H116.573V150.979Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.325 150.979H118.781V156.523H124.325V150.979Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.825 158.203H103.281V163.747H108.825V158.203Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.573 158.203H111.029V163.747H116.573V158.203Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.325 158.203H118.781V163.747H124.325V158.203Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.825 167.347H103.281V173.899H108.825V167.347Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.573 165.427H111.029V173.899H116.573V165.427Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.325 167.347H118.781V173.899H124.325V167.347Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.825 129.307H103.737V134.851H108.825V129.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.577 129.307H111.489V134.851H116.577V129.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.329 129.307H119.241V134.851H124.329V129.307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.825 136.531H103.737V142.075H108.825V136.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.577 136.531H111.489V142.075H116.577V136.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.329 136.531H119.241V142.075H124.329V136.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.825 143.755H103.737V149.299H108.825V143.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.577 143.755H111.489V149.299H116.577V143.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.329 143.755H119.241V149.299H124.329V143.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.825 150.979H103.737V156.523H108.825V150.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.577 150.979H111.489V156.523H116.577V150.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.329 150.979H119.241V156.523H124.329V150.979Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.825 158.203H103.737V163.747H108.825V158.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.577 158.203H111.489V163.747H116.577V158.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.329 158.203H119.241V163.747H124.329V158.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.825 167.347H103.737V173.899H108.825V167.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M116.577 165.427H111.489V173.899H116.577V165.427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M124.329 167.347H119.241V173.899H124.329V167.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2397 124.887H136.91L135.792 127.272H100.363L99.2397 124.887Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.065 124.887H136.91L135.792 127.272H126.528L127.065 124.887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.593 98.8179H180.739V173.899H211.593V98.8179Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M204.211 98.8179H180.739V173.899H204.211V98.8179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.038 96.5952H179.289V98.9904H213.038V96.5952Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.038 96.5952H204.216V98.9904H213.038V96.5952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M211.598 98.9907H204.216V173.9H211.598V98.9907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.877 101.813H183.888V107.856H187.877V101.813Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.877 102.211H183.888V107.851H187.877V102.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.459 101.813H183.888V107.856H184.459V101.813Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16 101.813H190.171V107.856H194.16V101.813Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.16 102.211H190.171V107.851H194.16V102.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.742 101.813H190.171V107.856H190.742V101.813Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.443 101.813H196.454V107.856H200.443V101.813Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.443 102.211H196.454V107.851H200.443V102.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.025 101.813H196.454V107.856H197.025V101.813Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.877 110.914H183.888V116.957H187.877V110.914Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.877 111.312H183.888V116.952H187.877V111.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.459 110.914H183.888V116.957H184.459V110.914Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16 110.914H190.171V116.957H194.16V110.914Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.16 111.312H190.171V116.952H194.16V111.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.742 110.914H190.171V116.957H190.742V110.914Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.443 110.914H196.454V116.957H200.443V110.914Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.443 111.312H196.454V116.952H200.443V111.312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.025 110.914H196.454V116.957H197.025V110.914Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.877 120.01H183.888V126.053H187.877V120.01Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.877 120.413H183.888V126.053H187.877V120.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.459 120.01H183.888V126.053H184.459V120.01Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16 120.01H190.171V126.053H194.16V120.01Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.16 120.413H190.171V126.053H194.16V120.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.742 120.01H190.171V126.053H190.742V120.01Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.443 120.01H196.454V126.053H200.443V120.01Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.443 120.413H196.454V126.053H200.443V120.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.025 120.01H196.454V126.053H197.025V120.01Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.877 129.11H183.888V135.154H187.877V129.11Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.877 129.514H183.888V135.154H187.877V129.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.459 129.11H183.888V135.154H184.459V129.11Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16 129.11H190.171V135.154H194.16V129.11Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.16 129.514H190.171V135.154H194.16V129.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.742 129.11H190.171V135.154H190.742V129.11Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.443 129.11H196.454V135.154H200.443V129.11Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.443 129.514H196.454V135.154H200.443V129.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.025 129.11H196.454V135.154H197.025V129.11Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.877 138.211H183.888V144.255H187.877V138.211Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.877 138.61H183.888V144.25H187.877V138.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.459 138.211H183.888V144.255H184.459V138.211Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16 138.211H190.171V144.255H194.16V138.211Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.16 138.61H190.171V144.25H194.16V138.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.742 138.211H190.171V144.255H190.742V138.211Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.443 138.211H196.454V144.255H200.443V138.211Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.443 138.61H196.454V144.25H200.443V138.61Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.025 138.211H196.454V144.255H197.025V138.211Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.877 147.307H183.888V153.35H187.877V147.307Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.877 147.71H183.888V153.35H187.877V147.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.459 147.307H183.888V153.35H184.459V147.307Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16 147.307H190.171V153.35H194.16V147.307Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.16 147.71H190.171V153.35H194.16V147.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.742 147.307H190.171V153.35H190.742V147.307Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.443 147.307H196.454V153.35H200.443V147.307Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.443 147.71H196.454V153.35H200.443V147.71Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.025 147.307H196.454V153.35H197.025V147.307Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.877 156.408H183.888V162.451H187.877V156.408Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.877 156.812H183.888V162.452H187.877V156.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.459 156.408H183.888V162.451H184.459V156.408Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16 156.408H190.171V162.451H194.16V156.408Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.16 156.812H190.171V162.452H194.16V156.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.742 156.408H190.171V162.451H190.742V156.408Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.443 156.408H196.454V162.451H200.443V156.408Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.443 156.812H196.454V162.452H200.443V156.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.025 156.408H196.454V162.451H197.025V156.408Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.877 165.509H183.888V171.552H187.877V165.509Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M187.877 165.907H183.888V171.547H187.877V165.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.459 165.509H183.888V171.552H184.459V165.509Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16 165.509H190.171V171.552H194.16V165.509Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.16 165.907H190.171V171.547H194.16V165.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.742 165.509H190.171V171.552H190.742V165.509Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.443 165.509H196.454V171.552H200.443V165.509Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M200.443 165.907H196.454V171.547H200.443V165.907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.025 165.509H196.454V171.552H197.025V165.509Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.553 56.2417H145.867V71.0257H146.553V56.2417Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.472 56.2417H160.785V71.0257H161.472V56.2417Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.379 62.9761H151.19V75.2305H174.379V62.9761Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M174.379 62.9761H151.19V75.2305H174.379V62.9761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.968 62.9761H137.779V75.2305H160.968V62.9761Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.968 62.9761H137.779V75.2305H160.968V62.9761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.576 81.8018H134.414V86.6018H135.576V81.8018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.576 94.1953H134.414V98.9953H135.576V94.1953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.576 102.586H134.414V107.386H135.576V102.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.576 110.981H134.414V115.781H135.576V110.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.576 119.371H134.414V124.171H135.576V119.371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.576 127.762H134.414V132.562H135.576V127.762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.576 137.011H134.414V141.811H135.576V137.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.576 146.261H134.414V151.061H135.576V146.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.576 155.506H134.414V160.306H135.576V155.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M135.576 164.755H134.414V169.555H135.576V164.755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.907 75.4082H144.672V173.899H180.907V75.4082Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.486 75.4082H131.251V173.899H167.486V75.4082Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M180.902 76.7617H167.491V173.904H180.902V76.7617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M167.486 75.4082H131.251V173.899H167.486V75.4082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.054 79.7139H159.609V171.547H164.054V79.7139Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.491 79.7139H151.046V171.547H155.491V79.7139Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.928 79.7139H142.483V171.547H146.928V79.7139Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.36 79.7139H133.915V171.547H138.36V79.7139Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.054 80.8755H159.609V171.547H164.054V80.8755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.491 80.8755H151.046V171.547H155.491V80.8755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.928 80.8755H142.483V171.547H146.928V80.8755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M138.36 80.8755H133.915V171.547H138.36V80.8755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.356 79.7139H177.494V171.547H179.356V79.7139Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.766 79.7139H173.904V171.547H175.766V79.7139Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.171 79.7139H170.309V171.547H172.171V79.7139Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M179.357 80.8755H177.495V171.547H179.357V80.8755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M175.766 80.8755H173.904V171.547H175.766V80.8755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.171 80.8755H170.309V171.547H172.171V80.8755Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.129 72.6099H167.491V74.4579H180.129V72.6099Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.129 72.1587H131.251V74.4579H180.129V72.1587Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.843 74.4624H130.229V76.7616H181.843V74.4624Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.843 70.3105H130.229V72.6098H181.843V70.3105Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181.843 74.4624H130.229V76.7616H181.843V74.4624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M181.843 70.3105H130.229V72.6098H181.843V70.3105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M181.843 74.4624H167.491V76.7616H181.843V74.4624Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M181.843 70.3105H167.491V72.6098H181.843V70.3105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M152.155 62.9761H146.616V68.5153H152.155V62.9761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7201 107.386C86.0161 101.837 80.1217 99.9408 75.7969 102.01C75.1749 102.307 74.4724 102.393 73.797 102.253C73.1217 102.114 72.5107 101.757 72.0577 101.237C66.8257 95.568 58.3441 94.896 54.8257 100.243C54.4275 100.849 54.0899 101.492 53.8177 102.163C53.3858 103.244 52.6672 104.187 51.7393 104.89C51.109 105.358 50.5676 105.935 50.1409 106.594C48.999 108.487 48.4693 110.686 48.6241 112.891C48.6505 113.22 48.5823 113.55 48.4275 113.842C48.2727 114.134 48.0378 114.375 47.7505 114.538C46.7709 115.051 45.9433 115.812 45.3505 116.746C42.4993 121.066 43.7569 128.794 48.1585 133.982C52.0801 138.605 57.1729 139.666 60.2497 136.776C60.3748 136.656 60.5417 136.589 60.7153 136.589C60.8889 136.589 61.0557 136.656 61.1809 136.776C63.3985 138.768 65.9809 138.782 67.3105 136.622C67.3615 136.528 67.434 136.447 67.5221 136.386C67.6102 136.326 67.7114 136.286 67.8176 136.272C67.9237 136.257 68.0317 136.268 68.1329 136.303C68.2342 136.338 68.3257 136.397 68.4001 136.474C70.6849 138.763 73.4449 138.874 74.8513 136.622C75.1047 136.203 75.2985 135.751 75.4273 135.278C75.4469 135.178 75.4879 135.083 75.5476 135C75.6073 134.917 75.6842 134.848 75.7731 134.797C75.8619 134.747 75.9607 134.716 76.0625 134.707C76.1644 134.698 76.267 134.711 76.3633 134.746C77.8561 135.346 79.3201 135.086 80.3185 133.906C80.4176 133.783 80.5577 133.7 80.713 133.673C80.8683 133.646 81.0282 133.675 81.1633 133.757C86.2849 136.819 91.6849 136.229 94.6897 131.664C98.7073 125.554 96.9601 114.691 90.7201 107.386Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M90.7201 107.386C86.0161 101.837 80.1217 99.9408 75.7969 102.01C75.1749 102.307 74.4724 102.393 73.797 102.253C73.1217 102.114 72.5107 101.757 72.0577 101.237C66.8257 95.568 58.3441 94.896 54.8257 100.243C54.4275 100.849 54.0899 101.492 53.8177 102.163C53.3858 103.244 52.6672 104.187 51.7393 104.89C51.109 105.358 50.5676 105.935 50.1409 106.594C48.999 108.487 48.4693 110.686 48.6241 112.891C48.6505 113.22 48.5823 113.55 48.4275 113.842C48.2727 114.134 48.0378 114.375 47.7505 114.538C46.7709 115.051 45.9433 115.812 45.3505 116.746C42.4993 121.066 43.7569 128.794 48.1585 133.982C52.0801 138.605 57.1729 139.666 60.2497 136.776C60.3748 136.656 60.5417 136.589 60.7153 136.589C60.8889 136.589 61.0557 136.656 61.1809 136.776C63.3985 138.768 65.9809 138.782 67.3105 136.622C67.3615 136.528 67.434 136.447 67.5221 136.386C67.6102 136.326 67.7114 136.286 67.8176 136.272C67.9237 136.257 68.0317 136.268 68.1329 136.303C68.2342 136.338 68.3257 136.397 68.4001 136.474C70.6849 138.763 73.4449 138.874 74.8513 136.622C75.1047 136.203 75.2985 135.751 75.4273 135.278C75.4469 135.178 75.4879 135.083 75.5476 135C75.6073 134.917 75.6842 134.848 75.7731 134.797C75.8619 134.747 75.9607 134.716 76.0625 134.707C76.1644 134.698 76.267 134.711 76.3633 134.746C77.8561 135.346 79.3201 135.086 80.3185 133.906C80.4176 133.783 80.5577 133.7 80.713 133.673C80.8683 133.646 81.0282 133.675 81.1633 133.757C86.2849 136.819 91.6849 136.229 94.6897 131.664C98.7073 125.554 96.9601 114.691 90.7201 107.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4097 139.306L63.8689 143.669C63.5137 149.827 63.2209 164.011 63.2209 164.011L61.6369 173.928L75.6097 174.063C75.6097 174.063 74.9761 165.687 74.9761 165.235C74.9761 164.784 72.2737 148.738 72.2737 148.738L71.3137 139.752L78.5137 137.434L79.8289 133.431L85.1089 130.272L87.6961 126.082L86.6977 125.827L83.8177 129.696L80.4817 130.459L81.9217 126.898H80.3329L76.3633 135.154L71.2465 136.258L71.9137 124.666C67.8241 126.682 66.5137 123.322 66.5137 123.322C66.5137 123.322 64.8241 138.927 64.2289 140.703L61.5937 139.306L58.7137 134.544H57.5041L59.4097 139.306Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9616 158.669H38.256V167.741H38.9616V158.669Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.9616 158.669H38.256V167.741H38.9616V158.669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5874 158.669H52.8818V167.741H53.5874V158.669Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.5874 158.669H52.8818V167.741H53.5874V158.669Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3889 166.857H37.4833V167.961H54.3889V166.857Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.3889 166.857H37.4833V167.961H54.3889V166.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6065 167.928H37.9009V174.067H38.6065V167.928Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.6065 167.928H37.9009V174.067H38.6065V167.928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0385 167.928H53.3329V174.067H54.0385V167.928Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.0385 167.928H53.3329V174.067H54.0385V167.928Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3889 159.077H37.4833V164.414H54.3889V159.077Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.3889 159.077H37.4833V164.414H54.3889V159.077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3554 167.741H37.5074V169.459H54.3554V167.741Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.3554 167.741H37.5074V169.459H54.3554V167.741Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5074 165.297H36.8018V174.057H37.5074V165.297Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7809 164.419H36.5521V165.648H37.7809V164.419Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.7809 164.419H36.5521V165.648H37.7809V164.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7361 164.419H37.7761V165.648H38.7361V164.419Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3601 174.058H55.0657V165.298H54.3601V174.058Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0912 165.643H55.3152V164.414H54.0912V165.643Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.0912 165.643H55.3152V164.414H54.0912V165.643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0864 164.419H53.1264V165.648H54.0864V164.419Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M38.7361 164.419H37.7761V165.648H38.7361V164.419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.0864 164.419H53.1264V165.648H54.0864V164.419Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4786 97.416H36.8594V100.123H37.4786V97.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6738 96.2881C37.8338 96.7681 32.0258 98.0545 27.4706 100.45V101.357C31.8807 98.9862 36.7189 97.5176 41.7026 97.0369L41.6738 96.2881Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3412 97.6369C48.0948 97.4242 47.8182 97.2495 47.5204 97.1185C46.8628 96.8353 42.8836 97.4304 41.5204 97.6464V97.0657L41.4868 96.312C42.4132 96.216 43.2436 96.1489 43.9444 96.1057C45.0916 96.0433 45.9412 96.0049 46.57 95.9857C46.7953 95.9754 47.0203 96.0102 47.232 96.088C47.4437 96.1658 47.6377 96.2851 47.8027 96.4389C47.9676 96.5927 48.1002 96.7779 48.1927 96.9836C48.2852 97.1893 48.3356 97.4114 48.3412 97.6369Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4707 106.834C27.3434 106.834 27.2213 106.783 27.1312 106.693C27.0412 106.603 26.9907 106.481 26.9907 106.354C26.9907 106.109 26.9907 105.6 29.5443 103.291C29.9036 102.96 30.2853 102.654 30.6867 102.375C33.0353 100.875 35.6704 99.8813 38.4243 99.4562C38.5516 99.4396 38.6802 99.4743 38.7819 99.5527C38.8837 99.631 38.9501 99.7465 38.9667 99.8738C38.9832 100.001 38.9485 100.13 38.8702 100.231C38.7919 100.333 38.6764 100.4 38.5491 100.416C38.5107 100.416 34.4259 100.992 31.2291 103.176C30.8623 103.431 30.5142 103.712 30.1875 104.016C28.5267 105.519 27.9987 106.224 27.9459 106.416C27.9307 106.532 27.8742 106.638 27.7868 106.714C27.6994 106.791 27.587 106.834 27.4707 106.834Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8323 100.32H27.7923C27.8229 100.32 27.8522 100.332 27.8738 100.354C27.8954 100.376 27.9075 100.405 27.9075 100.435V174.101H26.7075V100.426C26.7087 100.411 26.7129 100.396 26.7199 100.382C26.7268 100.369 26.7363 100.357 26.7479 100.347C26.7595 100.337 26.773 100.33 26.7875 100.325C26.8019 100.321 26.8172 100.319 26.8323 100.32Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.346 97.6896V97.728L42.7732 98.2512L41.5348 97.728V97.6464C42.898 97.4304 46.8772 96.8352 47.5348 97.1184C47.8276 97.2507 48.0993 97.4254 48.3412 97.6368C48.3454 97.6541 48.347 97.6719 48.346 97.6896Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M48.346 97.6896V97.728L42.7732 98.2512L41.5348 97.728V97.6464C42.898 97.4304 46.8772 96.8352 47.5348 97.1184C47.8276 97.2507 48.0993 97.4254 48.3412 97.6368C48.3454 97.6541 48.347 97.6719 48.346 97.6896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.531 131.895H191.774C191.814 131.895 191.852 131.91 191.88 131.938C191.907 131.966 191.923 132.004 191.923 132.043V177.831H190.382V132.043C190.382 132.004 190.398 131.966 190.426 131.938C190.454 131.91 190.492 131.895 190.531 131.895Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.48 133.138H183.768C182.83 133.138 182.069 133.898 182.069 134.837V137.578C182.069 138.516 182.83 139.277 183.768 139.277H198.48C199.418 139.277 200.179 138.516 200.179 137.578V134.837C200.179 133.898 199.418 133.138 198.48 133.138Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M198.48 133.138H183.768C182.83 133.138 182.069 133.898 182.069 134.837V137.578C182.069 138.516 182.83 139.277 183.768 139.277H198.48C199.418 139.277 200.179 138.516 200.179 137.578V134.837C200.179 133.898 199.418 133.138 198.48 133.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.019 133.594H184.315C183.377 133.594 182.616 134.354 182.616 135.293V137.04C182.616 137.979 183.377 138.739 184.315 138.739H198.019C198.958 138.739 199.718 137.979 199.718 137.04V135.293C199.718 134.354 198.958 133.594 198.019 133.594Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.984 136.723L196.07 136.536C196.196 136.629 196.347 136.679 196.502 136.68C196.704 136.68 196.79 136.603 196.79 136.507C196.79 136.229 196.013 136.411 196.013 135.927C196.013 135.715 196.181 135.538 196.541 135.538C196.694 135.534 196.846 135.574 196.977 135.653L196.901 135.84C196.791 135.777 196.667 135.742 196.541 135.739C196.339 135.739 196.257 135.816 196.257 135.917C196.257 136.191 197.03 136.013 197.03 136.493C197.03 136.699 196.862 136.882 196.502 136.882C196.317 136.888 196.134 136.832 195.984 136.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.52 135.759H197.088V135.552H198.197V135.759H197.76V136.863H197.515L197.52 135.759Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.094 173.621H18.4177V178.689H220.094V173.621Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.094 173.621H18.4177V178.689H220.094V173.621Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.2947 173.621H28.8147V179.049H29.2947V173.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4051 173.621H73.9251V179.049H74.4051V173.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.516 173.621H119.036V179.049H119.516V173.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.626 173.621H164.146V179.049H164.626V173.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.736 173.621H209.256V179.049H209.736V173.621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.095 180.677H18.4178V183.029H220.095V180.677Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M220.095 180.677H18.4178V183.029H220.095V180.677Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.7678 198.523H96.6334C95.6734 199.325 94.0798 199.843 92.6062 200.074C90.9118 200.343 89.2462 200.333 87.5614 200.587C86.5485 200.727 85.5599 201.007 84.6238 201.418C84.4061 201.589 84.2023 201.776 84.0142 201.979C83.6734 202.349 83.6158 202.743 84.3742 202.963C86.6431 203.648 89.0718 203.586 91.3028 202.786C93.5338 201.987 95.4494 200.493 96.7678 198.523Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1326 202.613L82.5838 203.477C81.8974 203.578 81.8398 203.174 82.315 202.997C83.2174 202.963 84.9598 202.344 85.1326 202.613Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.7677 198.523H96.6333C95.6733 199.325 94.0796 199.843 92.606 200.074C90.9116 200.343 89.246 200.333 87.5612 200.587C86.5484 200.727 85.5598 201.007 84.6236 201.418C84.406 201.589 84.2021 201.776 84.014 201.979C83.6732 202.349 83.6156 202.743 84.374 202.963C86.643 203.648 89.0717 203.586 91.3027 202.786C93.5337 201.987 95.4493 200.493 96.7677 198.523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1325 202.613L82.5837 203.477C81.8973 203.578 81.8397 203.174 82.3149 202.997C83.2173 202.963 84.9597 202.344 85.1325 202.613Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.8271 196.575C95.8271 196.68 95.7695 196.795 95.7263 196.925C95.6831 197.055 95.6831 197.059 95.6591 197.127C95.6111 197.271 95.5535 197.419 95.4911 197.583L95.3807 197.837C95.3375 197.943 95.2943 198.043 95.2415 198.149C95.1887 198.255 95.1407 198.365 95.0831 198.475C95.0255 198.586 94.9727 198.696 94.9103 198.811C94.8479 198.927 94.7951 199.023 94.7327 199.128C94.6703 199.234 94.5887 199.378 94.5071 199.503L94.2815 199.853C94.1999 199.973 94.1183 200.088 94.0319 200.203C93.9455 200.319 93.8591 200.434 93.7679 200.549C93.6767 200.664 93.5807 200.784 93.4799 200.895C93.3791 201.005 93.2879 201.111 93.1871 201.216C93.0863 201.322 92.9759 201.432 92.8655 201.533C92.7631 201.455 92.6499 201.392 92.5295 201.346C92.261 201.208 91.9492 201.181 91.661 201.271C91.3729 201.361 91.1315 201.56 90.9887 201.826C90.9335 201.981 90.9191 202.147 90.9468 202.31C90.9745 202.472 91.0435 202.624 91.1471 202.752C90.9373 202.86 90.7208 202.955 90.4991 203.035L90.3119 203.098L90.1007 203.165C89.9988 203.199 89.8945 203.227 89.7887 203.247C89.7129 203.267 89.636 203.283 89.5583 203.295C89.4445 203.322 89.3291 203.343 89.2127 203.357L88.8191 203.395C88.6815 203.395 88.5375 203.395 88.3871 203.395C87.8389 203.393 87.2929 203.327 86.7599 203.199C86.4629 203.127 86.1697 203.041 85.8815 202.939C85.3428 202.746 84.8197 202.512 84.3167 202.239C84.1007 202.123 83.8847 201.999 83.6591 201.859C83.5004 201.789 83.3584 201.687 83.2426 201.557C83.1268 201.428 83.0399 201.276 82.9876 201.111C82.9354 200.945 82.919 200.771 82.9396 200.599C82.9602 200.426 83.0173 200.26 83.1071 200.112C83.2574 199.814 83.4358 199.531 83.6399 199.267C84.5297 198.743 85.5321 198.441 86.5631 198.384C88.2911 198.255 90.0287 198.576 91.7519 198.427C93.2495 198.298 94.8383 197.707 95.6879 196.507L95.8271 196.575Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3886 201.446L81.8782 202.454C81.1774 202.507 81.0478 201.806 81.5134 201.6C82.4494 201.696 84.139 200.952 84.3886 201.446Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.8271 196.575C95.8271 196.68 95.7695 196.795 95.7263 196.925C95.6831 197.055 95.6831 197.059 95.6591 197.127C95.6111 197.271 95.5535 197.419 95.4911 197.583L95.3807 197.837C95.3375 197.943 95.2943 198.043 95.2415 198.149C95.1887 198.255 95.1407 198.365 95.0831 198.475C95.0255 198.586 94.9727 198.696 94.9103 198.811C94.8479 198.927 94.7951 199.023 94.7327 199.128C94.6703 199.234 94.5887 199.378 94.5071 199.503L94.2815 199.853C94.1999 199.973 94.1183 200.088 94.0319 200.203C93.9455 200.319 93.8591 200.434 93.7679 200.549C93.6767 200.664 93.5807 200.784 93.4799 200.895C93.3791 201.005 93.2879 201.111 93.1871 201.216C93.0863 201.322 92.9759 201.432 92.8655 201.533C92.7631 201.455 92.6499 201.392 92.5295 201.346C92.261 201.208 91.9492 201.181 91.661 201.271C91.3729 201.361 91.1315 201.56 90.9887 201.826C90.9335 201.981 90.9191 202.147 90.9468 202.31C90.9745 202.472 91.0435 202.624 91.1471 202.752C90.9373 202.86 90.7208 202.955 90.4991 203.035L90.3119 203.098L90.1007 203.165C89.9988 203.199 89.8945 203.227 89.7887 203.247C89.7129 203.267 89.636 203.283 89.5583 203.295C89.4445 203.322 89.3291 203.343 89.2127 203.357L88.8191 203.395C88.6815 203.395 88.5375 203.395 88.3871 203.395C87.8389 203.393 87.2929 203.327 86.7599 203.199C86.4625 203.129 86.1693 203.042 85.8815 202.939C85.3412 202.75 84.8177 202.516 84.3167 202.239C84.1007 202.123 83.8847 201.999 83.6591 201.859C83.5004 201.789 83.3584 201.687 83.2426 201.557C83.1268 201.428 83.0399 201.276 82.9876 201.111C82.9354 200.945 82.919 200.771 82.9396 200.599C82.9602 200.426 83.0173 200.26 83.1071 200.112C83.2574 199.814 83.4358 199.531 83.6399 199.267C84.5297 198.743 85.5321 198.441 86.5631 198.384C88.2911 198.255 90.0287 198.576 91.7519 198.427C93.2495 198.298 94.8383 197.707 95.6879 196.507L95.8271 196.575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 198.629L144.077 198.595C144.948 198.92 145.887 199.02 146.808 198.888C147.893 198.778 148.91 198.499 149.99 198.374C150.637 198.295 151.291 198.305 151.934 198.403C152.1 198.473 152.261 198.554 152.414 198.648C152.683 198.821 152.784 199.056 152.357 199.31C151.075 200.11 149.571 200.475 148.066 200.353C146.56 200.23 145.135 199.625 144 198.629Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.81 199.234L153.518 199.344C153.955 199.296 153.926 199.037 153.605 199.008C153.043 199.133 151.886 199.032 151.81 199.234Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144 198.629L144.077 198.595C144.948 198.92 145.887 199.02 146.808 198.888C147.893 198.778 148.91 198.499 149.99 198.374C150.637 198.295 151.291 198.305 151.934 198.403C152.1 198.473 152.261 198.554 152.414 198.648C152.683 198.821 152.784 199.056 152.357 199.31C151.075 200.11 149.571 200.475 148.066 200.353C146.56 200.23 145.135 199.625 144 198.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.81 199.233L153.518 199.344C153.955 199.296 153.926 199.037 153.605 199.008C153.043 199.133 151.886 199.032 151.81 199.233Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.48 196.714L144.562 196.67C144.916 196.993 145.335 197.237 145.791 197.387C146.247 197.537 146.729 197.589 147.206 197.539C148.306 197.482 149.376 197.126 150.475 197.059C151.13 197.004 151.789 197.108 152.395 197.362C152.545 197.51 152.681 197.67 152.803 197.842C152.872 197.928 152.922 198.028 152.949 198.135C152.977 198.241 152.982 198.353 152.963 198.462C152.945 198.571 152.903 198.674 152.842 198.766C152.78 198.858 152.7 198.935 152.606 198.994C148.056 202.742 145.013 198.014 144.48 196.714Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.117 198.782L153.787 199.2C154.233 199.171 154.267 198.72 153.941 198.629C153.36 198.768 152.232 198.451 152.117 198.782Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.48 196.714L144.562 196.67C144.916 196.993 145.335 197.237 145.791 197.387C146.247 197.537 146.729 197.589 147.206 197.539C148.306 197.482 149.376 197.126 150.475 197.059C151.13 197.004 151.789 197.108 152.395 197.362C152.545 197.51 152.681 197.67 152.803 197.842C152.872 197.928 152.922 198.028 152.949 198.135C152.977 198.241 152.982 198.353 152.963 198.462C152.945 198.571 152.903 198.674 152.842 198.766C152.78 198.858 152.7 198.935 152.606 198.994C148.056 202.742 145.013 198.014 144.48 196.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.637 197.573L115.56 197.539C114.684 197.834 113.747 197.902 112.838 197.736C111.763 197.587 110.765 197.256 109.689 197.117C109.054 197.019 108.408 197.006 107.769 197.078C107.604 197.143 107.444 197.218 107.289 197.304C107.016 197.467 106.905 197.693 107.323 197.966C108.568 198.801 110.048 199.213 111.545 199.142C113.042 199.071 114.476 198.521 115.637 197.573Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.846 197.904L106.142 197.957C105.71 197.89 105.749 197.635 106.07 197.621C106.622 197.76 107.779 197.707 107.846 197.904Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.637 197.573L115.56 197.539C114.684 197.834 113.747 197.902 112.838 197.736C111.763 197.587 110.765 197.256 109.689 197.117C109.054 197.019 108.408 197.006 107.769 197.078C107.604 197.143 107.444 197.218 107.289 197.304C107.016 197.467 106.905 197.693 107.323 197.966C108.568 198.801 110.048 199.213 111.545 199.142C113.042 199.071 114.476 198.521 115.637 197.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.846 197.904L106.142 197.957C105.71 197.889 105.749 197.635 106.07 197.621C106.622 197.76 107.779 197.707 107.846 197.904Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.426 196.224C115.403 196.201 115.377 196.182 115.349 196.166C114.95 196.427 114.5 196.6 114.03 196.676C113.559 196.751 113.078 196.726 112.618 196.603C111.547 196.378 110.554 195.859 109.488 195.643C108.857 195.492 108.199 195.492 107.568 195.643C107.397 195.767 107.236 195.905 107.088 196.056C107.006 196.129 106.94 196.218 106.896 196.319C106.851 196.419 106.827 196.527 106.827 196.637C106.827 196.747 106.851 196.855 106.896 196.955C106.94 197.055 107.006 197.145 107.088 197.218C110.976 201.6 114.72 197.419 115.426 196.224Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.611 197.059L105.907 197.208C105.475 197.112 105.523 196.661 105.845 196.627C106.392 196.853 107.549 196.714 107.611 197.059Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M115.426 196.224C115.403 196.201 115.377 196.182 115.349 196.166C114.95 196.427 114.5 196.6 114.03 196.676C113.559 196.751 113.078 196.726 112.618 196.603C111.547 196.378 110.554 195.859 109.488 195.643C108.857 195.492 108.199 195.492 107.568 195.643C107.397 195.767 107.236 195.905 107.088 196.056C107.006 196.129 106.94 196.218 106.896 196.319C106.851 196.419 106.827 196.527 106.827 196.637C106.827 196.747 106.851 196.855 106.896 196.955C106.94 197.055 107.006 197.145 107.088 197.218C110.976 201.6 114.72 197.419 115.426 196.224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.968 202.157H170.03C170.674 201.828 171.39 201.663 172.113 201.677C172.963 201.677 173.779 201.778 174.629 201.768C175.135 201.769 175.639 201.699 176.126 201.562C176.245 201.493 176.357 201.414 176.462 201.327C176.654 201.168 176.712 200.981 176.357 200.818C175.289 200.327 174.091 200.192 172.941 200.433C171.791 200.674 170.748 201.279 169.968 202.157Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.958 200.942L177.269 200.693C177.614 200.693 177.614 200.89 177.369 200.942C176.923 200.899 176.035 201.086 175.958 200.942Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.968 202.157H170.03C170.674 201.828 171.39 201.663 172.113 201.677C172.963 201.677 173.779 201.778 174.629 201.768C175.135 201.769 175.639 201.699 176.126 201.562C176.245 201.493 176.357 201.414 176.462 201.327C176.654 201.168 176.712 200.981 176.357 200.818C175.289 200.327 174.091 200.192 172.941 200.433C171.791 200.674 170.748 201.279 169.968 202.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.958 200.943L177.269 200.693C177.614 200.693 177.614 200.89 177.369 200.943C176.923 200.9 176.035 201.087 175.958 200.943Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.944 202.004L170.011 202.037C170.287 201.785 170.613 201.594 170.968 201.478C171.323 201.361 171.699 201.321 172.07 201.36C172.929 201.408 173.76 201.682 174.614 201.74C175.125 201.781 175.638 201.7 176.112 201.504C176.229 201.387 176.337 201.26 176.433 201.125C176.487 201.058 176.526 200.98 176.547 200.897C176.569 200.814 176.573 200.727 176.558 200.642C176.543 200.557 176.511 200.476 176.463 200.405C176.415 200.334 176.353 200.273 176.28 200.228C172.728 197.304 170.352 200.986 169.944 202.004Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.891 200.39L177.192 200.069C177.538 200.069 177.557 200.443 177.312 200.51C176.861 200.4 175.978 200.64 175.891 200.39Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.944 202.004L170.011 202.037C170.287 201.785 170.613 201.594 170.968 201.478C171.323 201.361 171.699 201.321 172.07 201.36C172.929 201.408 173.76 201.682 174.614 201.74C175.125 201.781 175.638 201.7 176.112 201.504C176.229 201.387 176.337 201.26 176.433 201.125C176.487 201.058 176.526 200.98 176.547 200.897C176.569 200.814 176.573 200.727 176.558 200.642C176.543 200.557 176.511 200.476 176.463 200.405C176.415 200.334 176.353 200.273 176.28 200.228C172.728 197.304 170.352 200.986 169.944 202.004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0639 200.059H70.9727C70.2094 199.469 69.3099 199.079 68.3567 198.927C67.2479 198.701 66.1535 198.667 65.0399 198.447C64.3742 198.328 63.7281 198.118 63.1199 197.823C62.9809 197.703 62.8509 197.573 62.7311 197.434C62.5199 197.179 62.4911 196.92 62.9951 196.795C64.5123 196.402 66.1157 196.507 67.5687 197.095C69.0216 197.682 70.247 198.722 71.0639 200.059Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4895 197.05L61.8335 196.416C61.3823 196.33 61.3535 196.594 61.6463 196.719C62.2367 196.772 63.3599 197.223 63.4895 197.05Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.0639 200.059H70.9727C70.2094 199.469 69.3098 199.079 68.3567 198.927C67.2479 198.701 66.1535 198.667 65.0399 198.447C64.3742 198.328 63.7281 198.118 63.1199 197.823C62.9808 197.703 62.8509 197.573 62.7311 197.434C62.5199 197.179 62.4911 196.92 62.9951 196.795C64.5122 196.402 66.1157 196.507 67.5686 197.095C69.0216 197.682 70.247 198.722 71.0639 200.059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4895 197.05L61.8335 196.416C61.3823 196.33 61.3535 196.594 61.6463 196.719C62.2367 196.772 63.3599 197.223 63.4895 197.05Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.1311 199.867L71.0351 199.891C70.731 199.497 70.3472 199.172 69.9089 198.936C69.4706 198.701 68.9875 198.56 68.4911 198.523C67.3583 198.379 66.2015 198.523 65.0639 198.413C64.3802 198.349 63.7217 198.122 63.1439 197.751C63.0165 197.571 62.9072 197.38 62.8175 197.179C62.7625 197.079 62.7293 196.969 62.7203 196.855C62.7113 196.741 62.7265 196.626 62.7651 196.519C62.8037 196.411 62.8647 196.313 62.9441 196.231C63.0235 196.149 63.1194 196.084 63.2255 196.042C68.5919 193.047 70.8383 198.437 71.1311 199.867Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.715 196.344L62.083 195.615C61.603 195.562 61.5166 196.018 61.819 196.167C62.4382 196.133 63.5326 196.666 63.715 196.344Z",
    fill: "#E22C22"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.1311 199.867L71.0351 199.891C70.731 199.497 70.3472 199.172 69.9089 198.936C69.4706 198.701 68.9875 198.56 68.4911 198.523C67.3583 198.379 66.2015 198.523 65.0639 198.413C64.3802 198.349 63.7217 198.122 63.1439 197.751C63.0165 197.571 62.9072 197.38 62.8175 197.179C62.7625 197.079 62.7293 196.969 62.7203 196.855C62.7113 196.741 62.7265 196.626 62.7651 196.519C62.8037 196.411 62.8647 196.313 62.9441 196.231C63.0235 196.149 63.1194 196.084 63.2255 196.042C68.5919 193.047 70.8383 198.437 71.1311 199.867Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1284_323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/empty-data.22fde540322567ea92a8d31f01e7c19d.svg";
export { ForwardRef as ReactComponent };